import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LibraryComponent} from "./library/library.component";
import {HideRAComponent} from "./hide.ra.component";
import {SummaryComponent} from "./summary/summary.component";


const routes: Routes = [
    {path: "library", component: LibraryComponent},
    {path: "summary", component: SummaryComponent},
    {path: "hide", component: HideRAComponent}
];

@NgModule({
  //NOTE: Can enable routing tracing by: { enableTracing: true }
  imports: [RouterModule.forRoot(routes, { enableTracing: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
